{
  "$comment": "Design tokens shared by the web (CSS variables) and Flutter (ThemeData) clients. Add a theme here and both apps pick it up. Colors are hex; 'mode' drives platform defaults (scrollbars, status bar, chart contrast).",
  "defaultTheme": "clinical",
  "themes": [
    {
      "id": "clinical",
      "nameKey": "themes.clinical",
      "mode": "light",
      "colors": {
        "primary": "#1565C0",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#E3EEFB",
        "background": "#F4F6FA",
        "surface": "#FFFFFF",
        "surfaceAlt": "#EEF1F6",
        "border": "#D9DEE7",
        "text": "#14213D",
        "textMuted": "#5B6578",
        "success": "#2E7D32",
        "warning": "#B26A00",
        "danger": "#C62828",
        "info": "#0277BD",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3E0",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E1F2FB",
        "sidebar": "#0F2A4A",
        "onSidebar": "#DCE6F5",
        "sidebarActive": "#1E4E86",
        "chart1": "#1565C0",
        "chart2": "#00897B",
        "chart3": "#F9A825"
      }
    },
    {
      "id": "gold",
      "nameKey": "themes.gold",
      "mode": "light",
      "colors": {
        "primary": "#B8860B",
        "onPrimary": "#1A1405",
        "primarySoft": "#F7EED3",
        "background": "#F2F1EC",
        "surface": "#FFFFFF",
        "surfaceAlt": "#F4F1E6",
        "border": "#E2DCC8",
        "text": "#1F1C14",
        "textMuted": "#6B6455",
        "success": "#2E7D32",
        "warning": "#B26A00",
        "danger": "#C62828",
        "info": "#0277BD",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3E0",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E1F2FB",
        "sidebar": "#24221D",
        "onSidebar": "#EDE6D3",
        "sidebarActive": "#4A3F1E",
        "chart1": "#B8860B",
        "chart2": "#00796B",
        "chart3": "#4A3AA7"
      }
    },
    {
      "id": "oph",
      "nameKey": "themes.oph",
      "mode": "light",
      "colors": {
        "primary": "#B8102A",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#FBE6E9",
        "background": "#F5F3EE",
        "surface": "#FFFFFF",
        "surfaceAlt": "#F4EFE2",
        "border": "#E2DAC6",
        "text": "#0F1F4B",
        "textMuted": "#56607E",
        "success": "#2E7D32",
        "warning": "#A86A00",
        "danger": "#C62828",
        "info": "#1D4FB8",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3DC",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E4ECFB",
        "sidebar": "#0A2466",
        "onSidebar": "#F4E7C5",
        "sidebarActive": "#B8102A",
        "chart1": "#B8102A",
        "chart2": "#1D4FB8",
        "chart3": "#D4A017"
      }
    },
    {
      "id": "night",
      "nameKey": "themes.night",
      "mode": "dark",
      "colors": {
        "primary": "#64B5F6",
        "onPrimary": "#0B1726",
        "primarySoft": "#17324F",
        "background": "#0E141B",
        "surface": "#161E28",
        "surfaceAlt": "#1D2733",
        "border": "#2B3746",
        "text": "#E6EDF5",
        "textMuted": "#9AA8B8",
        "success": "#66BB6A",
        "warning": "#FFB74D",
        "danger": "#EF5350",
        "info": "#4FC3F7",
        "successSoft": "#1B3121",
        "warningSoft": "#3A2C15",
        "dangerSoft": "#3B1C1E",
        "infoSoft": "#123142",
        "sidebar": "#0A1017",
        "onSidebar": "#C9D5E3",
        "sidebarActive": "#1C2E44",
        "chart1": "#3B8EE0",
        "chart2": "#4DB6AC",
        "chart3": "#FFD54F"
      }
    },
    {
      "id": "ocean",
      "nameKey": "themes.ocean",
      "mode": "light",
      "colors": {
        "primary": "#00796B",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#E0F2F1",
        "background": "#F2F8F8",
        "surface": "#FFFFFF",
        "surfaceAlt": "#E8F2F1",
        "border": "#CFE1DF",
        "text": "#0F2E2B",
        "textMuted": "#4F6A67",
        "success": "#2E7D32",
        "warning": "#B26A00",
        "danger": "#C62828",
        "info": "#0277BD",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3E0",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E1F2FB",
        "sidebar": "#004D45",
        "onSidebar": "#D5EEEA",
        "sidebarActive": "#00695C",
        "chart1": "#00897B",
        "chart2": "#0288D1",
        "chart3": "#F57C00"
      }
    },
    {
      "id": "forest",
      "nameKey": "themes.forest",
      "mode": "light",
      "colors": {
        "primary": "#2E7D32",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#E8F5E9",
        "background": "#F5F8F2",
        "surface": "#FFFFFF",
        "surfaceAlt": "#EDF3E8",
        "border": "#D6E2CF",
        "text": "#1B2E1C",
        "textMuted": "#55685A",
        "success": "#2E7D32",
        "warning": "#B26A00",
        "danger": "#C62828",
        "info": "#0277BD",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3E0",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E1F2FB",
        "sidebar": "#1F3B22",
        "onSidebar": "#DDEBDD",
        "sidebarActive": "#2F5A33",
        "chart1": "#2E7D32",
        "chart2": "#6D4C41",
        "chart3": "#F9A825"
      }
    },
    {
      "id": "lotus",
      "nameKey": "themes.lotus",
      "mode": "light",
      "colors": {
        "primary": "#AD1457",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#FCE4EC",
        "background": "#FBF6F8",
        "surface": "#FFFFFF",
        "surfaceAlt": "#F6ECF0",
        "border": "#EAD3DC",
        "text": "#3A1426",
        "textMuted": "#7A5565",
        "success": "#2E7D32",
        "warning": "#B26A00",
        "danger": "#C62828",
        "info": "#0277BD",
        "successSoft": "#E6F4E7",
        "warningSoft": "#FFF3E0",
        "dangerSoft": "#FDECEC",
        "infoSoft": "#E1F2FB",
        "sidebar": "#4A0E2A",
        "onSidebar": "#F6DCE7",
        "sidebarActive": "#7B1B47",
        "chart1": "#AD1457",
        "chart2": "#5E35B1",
        "chart3": "#00897B"
      }
    },
    {
      "id": "midnight",
      "nameKey": "themes.midnight",
      "mode": "dark",
      "colors": {
        "primary": "#9FA8DA",
        "onPrimary": "#12142B",
        "primarySoft": "#262B52",
        "background": "#11121F",
        "surface": "#191B2E",
        "surfaceAlt": "#21243B",
        "border": "#33375A",
        "text": "#E8E9F5",
        "textMuted": "#A3A6C4",
        "success": "#81C784",
        "warning": "#FFB74D",
        "danger": "#E57373",
        "info": "#81D4FA",
        "successSoft": "#1D3322",
        "warningSoft": "#3A2C15",
        "dangerSoft": "#3B1E22",
        "infoSoft": "#172F3E",
        "sidebar": "#0B0C16",
        "onSidebar": "#CDD0EA",
        "sidebarActive": "#262B52",
        "chart1": "#6E7FEA",
        "chart2": "#80CBC4",
        "chart3": "#FFE082"
      }
    },
    {
      "id": "contrast",
      "nameKey": "themes.contrast",
      "mode": "light",
      "colors": {
        "primary": "#0033CC",
        "onPrimary": "#FFFFFF",
        "primarySoft": "#DCE4FF",
        "background": "#FFFFFF",
        "surface": "#FFFFFF",
        "surfaceAlt": "#F0F0F0",
        "border": "#000000",
        "text": "#000000",
        "textMuted": "#262626",
        "success": "#006400",
        "warning": "#8A4B00",
        "danger": "#B00000",
        "info": "#00508C",
        "successSoft": "#E0F2E0",
        "warningSoft": "#FFF0DB",
        "dangerSoft": "#FFE0E0",
        "infoSoft": "#DDEEFF",
        "sidebar": "#000000",
        "onSidebar": "#FFFFFF",
        "sidebarActive": "#0033CC",
        "chart1": "#2563EB",
        "chart2": "#B00000",
        "chart3": "#006400"
      }
    }
  ],
  "accents": [
    "#1565C0",
    "#00796B",
    "#2E7D32",
    "#AD1457",
    "#6A1B9A",
    "#E65100",
    "#C62828",
    "#37474F"
  ],
  "radius": {
    "sm": 6,
    "md": 10,
    "lg": 14
  },
  "fonts": {
    "lo": [
      "Noto Sans Lao",
      "Phetsarath OT",
      "sans-serif"
    ],
    "th": [
      "Noto Sans Thai",
      "Sarabun",
      "sans-serif"
    ],
    "zh": [
      "PingFang SC",
      "Microsoft YaHei",
      "Noto Sans SC",
      "sans-serif"
    ],
    "vi": [
      "Noto Sans",
      "Segoe UI",
      "Roboto",
      "sans-serif"
    ],
    "en": [
      "Inter",
      "Noto Sans",
      "Segoe UI",
      "Roboto",
      "sans-serif"
    ]
  },
  "categorical": {
    "$comment": "Validated categorical order (dataviz reference palette): assign in this order, never cycled; light slots 3-5 are below 3:1 so charts carry direct labels or a table view.",
    "light": [
      "#2a78d6",
      "#eb6834",
      "#1baf7a",
      "#eda100",
      "#e87ba4",
      "#008300",
      "#4a3aa7",
      "#e34948"
    ],
    "dark": [
      "#3987e5",
      "#d95926",
      "#199e70",
      "#c98500",
      "#d55181",
      "#008300",
      "#9085e9",
      "#e66767"
    ],
    "previous": {
      "light": "#c3c2b7",
      "dark": "#55544f"
    }
  }
}
